<template>
  <div
    id="users"
    class="row"
  >
    <div class="col-12">
      <vuetify-table
        :headers="headers"
        :api-u-r-l="apiURL"
        title="Libro de Venta"
        :refresh="refresh"
        permisosNuevoRegistro="generar-libro"
      />
    </div>
  </div>
</template>

<script>
import VuetifyTable from '~/components/VuetifyTable';

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('salebook') };
  },
  components: {
    VuetifyTable,
  },
  data: () => ({
    headers: [
      {
        text: 'RIF',
        value: 'rif',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Razón Social',
        value: 'business_name',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Fecha Inicio',
        value: 'date_start',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Fecha Fin',
        value: 'date_end',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Descargas',
        value: 'download_count',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Estado',
        value: 'status_salebook',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Fecha',
        value: 'created_at',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Acciones',
        value: 'action_salebook',
        align: 'left',
        sortable: false,
      },
    ],
    items: [],
    totalItems: 0,
    refresh: true,
    apiURL: 'api/salebook',
  }),
  methods: {

  },
};
</script>
